/**
 * @file Charge-summary state badge: renders the charge's paid/removed/snoozed
 * state plus a direct-payment label (shown only for DIRECT_UNTRACKED).
 *
 * Flow: rendered inside the charge-summary panel → reads `props.charge`.
 * Exceptions: none.
 */
import * as React from "react";
import Component from "../../AbstractComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { PAYMENT_ROUTE } from "../../../Entity/Entities/Charge/PaymentRoute";

export default class Charge2State extends Component {
  public state = {

  };

  constructor(public props) {
    super(props);
  }

  public renderRemovedState = () => {
    return (
      <div style={{ fontSize: "16px", color: "#F44336" }}>
        {this.trans("charge-summary-state/removed").toUpperCase()}
      </div>
    );
  }

  public renderUnpaidState = () => {
    return (
      <div style={{ fontSize: "16px", color: "#F44336" }}>
        {this.props.isSettled ? this.trans("payment-summary-state/unused").toUpperCase() : this.trans("charge-summary-state/unpaid").toUpperCase()}
      </div>
    );
  }

  public renderPaidState = () => {
    return (
      <div style={{ fontSize: "16px", color: "#43A047" }}>
        {this.props.isSettled ? this.trans("status-used").toUpperCase() : this.trans("charge-summary-state/paid").toUpperCase()}
      </div>
    );
  }

  public renderReceivedState = () => {
    return (
      <div style={{ fontSize: "16px", color: "#43A047" }}>
        {this.props.isSettled ? this.trans("status-used").toUpperCase() : this.trans("charge-summary-state/received").toUpperCase()}
      </div>
    );
  }

  public renderPartialPaidState = (charge: ChargeInterface) => {
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
          <div className="class" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", fontSize: "16px" }}>
            {this.props.isSettled ?
              this.trans("status-used").toLowerCase()
              : charge?.isReceivable ? this.trans("charge-summary-state/remainingtoreceive") : this.trans("charge-summary-state/remainingtopay")}
          </div>
          <div className="currency" style={{ fontSize: "16px" }}>
            {charge?.currency?.getIso()}
          </div>
          <div className="amount" style={this.props.isSettled ? { fontSize: "16px" } : { color: "#F5A623", fontSize: "16px" }}>
            {this.props.isSettled ? this.formatter.formatNumber(this.props.settlementAmount) : this.formatter.formatNumber(charge?.amountRemaining)}
          </div>
        </div>
      </div>
    );
  }

  public renderContent = (charge: ChargeInterface) => {
    if (charge?.amount === 0) {
      return
    }
    if (charge?.removed) {
      return this.renderRemovedState();
    }
    if (charge?.amountPaid === 0) {
      return this.renderUnpaidState();
    }
    if (!this.props.isSettled) {
      if (charge?.isFullyPaid()) {
        if (charge?.isReceivable) {
          return this.renderReceivedState();
        }
        return this.renderPaidState();
      }

      if (charge?.amountRemaining > 0) {
        return this.renderPartialPaidState(charge);
      }
    } else {
      if (this.props.settlementAmount === charge?.amount) {
        return this.renderPaidState();
      } else if (this.props.settlementAmount < charge?.amount) {
        return this.renderPartialPaidState(charge);
      } else {
        return this.renderUnpaidState();
      }
    }
  }

  public render() {
    const charge: ChargeInterface = this.props.charge;

		return (
			<div 
				className={`charge-state-title-presentation charge-state`}
				style={{
					padding: "0", 
					fontWeight: "bold", 
					fontSize: "16px",
					display: "flex",
					justifyContent: "flex-end"
				}}
			>
				{this.renderContent(charge)}
        {
							charge?.paymentRouteId === PAYMENT_ROUTE.DIRECT_UNTRACKED && (
								<div style={{position: "absolute", top: "28px"}}>
									<div className="list-label creation-type-label">
										{this.trans("label-direct")}
									</div>
								</div>
							)
						}
			</div>
		);
  }
}
